import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConsultationsList from './consultations/ConsultationsList';

class HomePage extends React.Component {
  render() {
    return (
      <div>
        <div className="row top">
          <div className="col-sm-2" />
          <div className="col-sm-3" />
          <div className="col-sm-7 header">
            <h1>Aktualnie trwające konsultacje</h1>
          </div>
        </div>
        
        <ConsultationsList />
      </div>
    );
  }
}

HomePage.propTypes = {
  cms: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage.js